import { atom } from "nanostores";

export const client_config = atom<any>({});
